import styled from 'styled-components';

// Bolinha de "há pedidos em análise" ao lado do título do item, no fundo
// escuro do menu. Laranja do tema (`orange._900`), fixo aqui como o resto do
// Sidebar.
export const Dot = styled.span`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ff9900;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.15);
`;
